<div class="site__header header"
  color="primary">
  <button mat-icon-button
    (click)="onToggleMenuButton()"
    *ngIf="storeService.store.activeBreakpoints.isXSmall"
    class="position-absolute left-0 toggle-menu-button">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="w-100 d-flex align-items-center justify-content-center">
    <span>
      <a [routerLink]="['/']"
        aria-label="Go to homepage">
        <img class="logo pointer"
          alt="Markwins Beauty Brands Logo"
          src="assets/img/logo_markwins.png" />
      </a>
    </span>
  </div>

  <nav id="site-navigation"
    *ngIf="!storeService.store.activeBreakpoints.isXSmall"
    class="header__navigation">
    <ul id="primary-menu"
      class="primary-menu nav-menu">

      <!-- About -->
      <li class="no-link has-mega-menu primary-menu__item">
        <a class="menu-link"
          href="#"
          tabindex="0"
          target="_self"
          (click)="openSubMenu($event)"
          (focus)="menuItemClearHover($event)">
          About </a>
        <div class="primary-menu__mega-menu"
          aria-hidden="true">
          <ul class="primary-menu__sub-menu">
            <li class="mega-menu-column primary-menu__sub-item">
              <ul class="primary-menu__column brands-list">
                <li class=" primary-menu__column-item">
                  <a tabindex="-1"
                    [routerLink]="['about','who-we-are']"
                    target="_self"
                    (click)="onMenuItemClick($event)">
                    Who We Are </a>
                </li>
                <li class=" primary-menu__column-item">
                  <a tabindex="-1"
                    [routerLink]="['about','our-global-footprint']"
                    target="_self"
                    (click)="onMenuItemClick($event)">
                    Our Global Footprint </a>
                </li>
                <li class=" primary-menu__column-item">
                  <a tabindex="-1"
                    [routerLink]="['about','culture-values']"
                    target="_self"
                    (click)="onMenuItemClick($event)">
                    Culture &amp; Values </a>
                </li>
                <li class=" primary-menu__column-item">
                  <a tabindex="-1"
                    [routerLink]="['about','our-partnerships']"
                    target="_self"
                    (click)="onMenuItemClick($event)">
                    Our Partnerships </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </li>
      <!-- Brands -->
      <li class="has-mega-menu primary-menu__item">
        <a tabindex="0"
          href="#"
          [routerLink]="['/our-brands']"
          target="_self"
          (click)="openSubMenu($event)"
          (focus)="menuItemClearHover($event)">
          Our Brands </a>
        <div class="primary-menu__mega-menu"
          aria-hidden="true">
          <ul class="primary-menu__sub-menu">
            <li class="mega-menu-column primary-menu__sub-item">
              <ul class="primary-menu__column brands-list">
                <li class=" primary-menu__column-item"
                  *ngFor="let brand of storeService.store.brands">
                  <a class="menu-link"
                    tabindex="-1"
                    [routerLink]="['brand', brand.name, brand.id]"
                    (click)="onMenuItemClick($event)">
                    {{brand.name}}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </li>
      <!-- Follow Us -->
      <li class="social primary-menu__item">
        <a tabindex="0"
          href="#"
          target="_self"
          (click)="openSubMenu($event)"
          (focus)="menuItemClearHover($event)">
          Follow Us </a>
        <div class="primary-menu__mega-menu"
          aria-hidden="true">
          <ul class="primary-menu__sub-menu">
            <li class="mega-menu-column primary-menu__sub-item">
              <ul class="primary-menu__column">

                <li class="social-item primary-menu__sub-item">

                  <ul class="social">
                    <li><a [href]="configs.social.tiktok"
                        tabindex="-1"
                        target="_self"
                        aria-label="Visit our TikTok page"
                        (click)="onMenuItemClick($event)">
                        <fa-icon [icon]="['fab', 'tiktok']"
                          size="lg"></fa-icon></a>
                    </li>
                    <li><a [href]="configs.social.instagram"
                        tabindex="-1"
                        target="_self"
                        aria-label="Visit our Instagram page"
                        (click)="onMenuItemClick($event)"><fa-icon [icon]="['fab', 'instagram']"
                          size="lg"></fa-icon></a>
                    </li>
                    <li><a [href]="configs.social.facebook"
                        tabindex="-1"
                        target="_self"
                        aria-label="Visit our Facebook page"
                        (click)="onMenuItemClick($event)"><fa-icon [icon]="['fab', 'facebook']"
                          size="lg"></fa-icon></a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </li>
      <!-- Press release -->
      <li class="primary-menu__item">
        <a class="menu-link"
          tabindex="0"
          [routerLink]="['/news']"
          target="_self"
          (focus)="menuItemClearHover($event)">
          News </a>
      </li>
    </ul>
  </nav>
</div>